module.exports = __webpack_public_path__ + "e020a0b50219d206c3cf5620433b7919.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-7.png
// module id = 2082
// module chunks = 0